const Constants = {
    maxTextLength: 50, // max text length for TextField
    minTextLength: 3 // min text length for TextField
}
const activityState = {
    IDLE: "idle",
    SILENTCHECK: "silent check",
    LOADING: "loading",
    WAIT: "wait",
    SUCCESS: "success",
    ERROR: "error",
  }
  export { Constants, activityState };
